import { doUpdateCurrentUserForOnboarding } from 'ducks/currentUser/operations'
import { doUpdateCompanyProfile } from '../../ducks/companyProfile'
import { V4_COMPANY_PAGE } from '../../pages'

export function doSaveAndRedirect(fields) {
  return dispatch => {
    const userFields = {
      name: fields.name,
      companyRole: fields.companyRole,
    }

    const companyFields = {
      phone: fields.phone,
    }

    return Promise.all([
      dispatch(doUpdateCurrentUserForOnboarding(userFields)),
      // NOTE (jscheel): This has optional fields, so we filter to avoid empty request
      Object.values(companyFields).filter(Boolean).length > 0
        ? dispatch(doUpdateCompanyProfile(companyFields))
        : Promise.resolve(),
    ]).then(() => {
      return dispatch({
        type: V4_COMPANY_PAGE,
      })
    })
  }
}
